import React from 'react';
import Select from 'react-select';
import {
  Button,
  Col,
  Form as BsForm,
  InputGroup,
  Row,
  Table,
} from 'react-bootstrap';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

// W-0651 — Combo GE (Status='A', vem do backend) + radio busca (código/apelido) + grid de contas.
// Paridade Ualteracodigoconta.pas: combo GE, radio "Por código"/"Por apelido", grid.
const SelecionarConta = ({
  opcoesGe,
  codigoGrupoEmpresa,
  onSelecionarGe,
  modo,
  onAlterarModo,
  busca,
  onAlterarBusca,
  onBuscar,
  contas,
  carregando,
  contaSelecionada,
  onSelecionarConta,
}) => {
  return (
    <>
      <Row>
        <Col xs={12} md={6}>
          <BsForm.Label className="small mb-1">Grupo de Empresa</BsForm.Label>
          <Select
            options={opcoesGe}
            value={opcoesGe.find((o) => o.value === codigoGrupoEmpresa) || null}
            onChange={(opt) => onSelecionarGe(opt ? opt.value : '')}
            styles={customStyles}
            components={{ DropdownIndicator }}
            placeholder="Selecione o Grupo de Empresa"
            isClearable
            noOptionsMessage={() => 'Nenhum grupo de empresa'}
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col xs={12} md={4}>
          <BsForm.Label className="small mb-1 d-block">Buscar por</BsForm.Label>
          <BsForm.Check
            inline
            type="radio"
            id="modo-codigo"
            name="modoBusca"
            label="Por código"
            checked={modo === 'codigo'}
            onChange={() => onAlterarModo('codigo')}
          />
          <BsForm.Check
            inline
            type="radio"
            id="modo-apelido"
            name="modoBusca"
            label="Por apelido"
            checked={modo === 'apelido'}
            onChange={() => onAlterarModo('apelido')}
          />
        </Col>
        <Col xs={12} md={8}>
          <BsForm.Label className="small mb-1">Busca</BsForm.Label>
          <InputGroup>
            <BsForm.Control
              type="text"
              value={busca}
              onChange={(e) => onAlterarBusca(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') onBuscar();
              }}
              placeholder={
                modo === 'codigo' ? 'Código da conta' : 'Apelido da conta'
              }
              disabled={!codigoGrupoEmpresa}
            />
            <Button
              variant="primary"
              onClick={onBuscar}
              disabled={!codigoGrupoEmpresa || carregando}
            >
              Buscar
            </Button>
          </InputGroup>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col xs={12}>
          <div style={{ maxHeight: 320, overflowY: 'auto' }}>
            <Table hover size="sm" responsive className="mb-0">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Apelido</th>
                  <th>Tipo</th>
                  <th>Subtipo</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {contas.length === 0 && (
                  <tr>
                    <td colSpan={5} className="text-center text-muted small py-3">
                      {carregando
                        ? 'Carregando...'
                        : 'Nenhuma conta encontrada.'}
                    </td>
                  </tr>
                )}
                {contas.map((conta) => (
                  <tr
                    key={`${conta.codigo_conta}`}
                    onClick={() => onSelecionarConta(conta)}
                    style={{ cursor: 'pointer' }}
                    className={
                      contaSelecionada &&
                      contaSelecionada.codigo_conta === conta.codigo_conta
                        ? 'table-primary'
                        : ''
                    }
                  >
                    <td>{conta.codigo_conta}</td>
                    <td>{conta.apelido_conta}</td>
                    <td>{conta.tipo}</td>
                    <td>{conta.subtipo || '-'}</td>
                    <td>{conta.status}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default SelecionarConta;
